import { render } from "./HoldSales.vue?vue&type=template&id=572dacf4&scoped=true"
import script from "./HoldSales.vue?vue&type=script&lang=js"
export * from "./HoldSales.vue?vue&type=script&lang=js"

import "./HoldSales.vue?vue&type=style&index=0&id=572dacf4&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572dacf4"]])

export default __exports__